<template>
<div class="bottom-0 bg-octo-primary">
  <footer class="footer container font-montserrat mx-auto px-10 py-20 2xl:px-28 lg:px-14 text-base-content mt-auto lg:flex justify-between">
  <div class="text-slate-300 font-sm flex flex-col">
    <span class="py-4 uppercase font-montserratbold font-bold text-slate-200 text-xl">Solutions</span> 
    <a class="link link-hover py-1" @click="solutionRedirect('#bg-1')"><i class='bx bx-chevron-right'></i> Gateway</a> 
    <a class="link link-hover py-1" @click="solutionRedirect('#bg-4')"><i class='bx bx-chevron-right'></i> Recharger</a> 
    <a class="link link-hover py-1" @click="solutionRedirect('#bg-6')"><i class='bx bx-chevron-right'></i> Messenger</a> 
  </div> 
  <div class="text-slate-100 flex flex-col">
    <span class="py-4 uppercase font-montserratbold font-bold text-slate-200 text-xl">Company</span> 
    <a class="link link-hover py-1" @click="redirectPage('aboutus')"><i class='bx bx-chevron-right'></i> About us</a> 
    <a class="link link-hover py-1" @click="aboutUsRedirect('#vision-mission')"><i class='bx bx-chevron-right'></i> Vision And Mission</a> 
    <a class="link link-hover py-1" @click="aboutUsRedirect('#whatwedo')"><i class='bx bx-chevron-right'></i> What we do</a> 
  </div> 
  <div class="text-slate-100 flex flex-col">
    <span class="py-4 uppercase font-montserratbold font-bold text-slate-200 text-xl">Contact  Information</span> 
    <a class="py-1">Building 9, 1st Floor, MICT Park, Hlaing Township, Yangon, Myanmar</a> 
    <a class="py-1">Phone: (+959) 882-551-244</a> 
    <div class="py-1">
    </div>

  </div>
</footer>
  <div class="flex items-cente justify-center bg-purple-900 py-3 text-slate-50 drop-shadow-lg">
    <span class="text-xs">Copyright © 2023 by <a href="https://mpss.com.mm"><img src="../assets/img/mpss-logo.png" alt="" class="w-10 inline-block"></a>. All rights reserved.</span>
    </div>
</div>
</template>

<script>

export default {
  
  methods: {
    redirectPage(param) {
      this.$router.push( '/'+ param);
    },
    async aboutUsRedirect(param)
    {
        await this.$router.push({name: 'About Us', hash: param});
    },
    async solutionRedirect(param)
    {
      await this.$router.push({name: 'Solutions', hash: param});
    },
  },
}
</script>

